/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import { ApiClient } from '../ApiClient';
import { TemplateQualitativeQuestionDTO } from './TemplateQualitativeQuestionDTO';
import { TemplateQuantitativeQuestionDTO } from './TemplateQuantitativeQuestionDTO';

/**
 * The TemplateCosoAmbitoDTO model module.
 * @module model/TemplateCosoAmbitoDTO
 * @version v0
 */
export class TemplateCosoAmbitoDTO {
  /**
   * Constructs a new <code>TemplateCosoAmbitoDTO</code>.
   * @alias module:model/TemplateCosoAmbitoDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TemplateCosoAmbitoDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TemplateCosoAmbitoDTO} obj Optional instance to populate.
   * @return {module:model/TemplateCosoAmbitoDTO} The populated <code>TemplateCosoAmbitoDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TemplateCosoAmbitoDTO();

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Number');
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (data.hasOwnProperty('position')) {
        obj['position'] = ApiClient.convertToType(data['position'], 'Number');
      }
      if (data.hasOwnProperty('dummy')) {
        obj['dummy'] = ApiClient.convertToType(data['dummy'], 'Boolean');
      }
      if (data.hasOwnProperty('isQualitative')) {
        obj['isQualitative'] = ApiClient.convertToType(data['isQualitative'], 'Boolean');
      }
      if (data.hasOwnProperty('isDeletable')) {
        obj['isDeletable'] = ApiClient.convertToType(data['isDeletable'], 'Boolean');
      }
      if (data.hasOwnProperty('active')) {
        obj['active'] = ApiClient.convertToType(data['active'], 'Boolean');
      }
      if (data.hasOwnProperty('templateQualitativeQuestions')) {
        obj['templateQualitativeQuestions'] = ApiClient.convertToType(data['templateQualitativeQuestions'], [TemplateQualitativeQuestionDTO]);
      }
      if (data.hasOwnProperty('templateQuantitativeQuestions')) {
        obj['templateQuantitativeQuestions'] = ApiClient.convertToType(data['templateQuantitativeQuestions'], [TemplateQuantitativeQuestionDTO]);
      }
      if (data.hasOwnProperty('tooltip')) {
        obj['tooltip'] = ApiClient.convertToType(data['tooltip'], 'String');
      }
      if (data.hasOwnProperty('poor')) {
        obj['poor'] = ApiClient.convertToType(data['poor'], 'Number');
      }
      if (data.hasOwnProperty('good')) {
        obj['good'] = ApiClient.convertToType(data['good'], 'Number');
      }
      if (data.hasOwnProperty('unsatisfactory')) {
        obj['unsatisfactory'] = ApiClient.convertToType(data['unsatisfactory'], 'Number');
      }
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
TemplateCosoAmbitoDTO.prototype.id = undefined;

/**
 * @member {String} title
 */
TemplateCosoAmbitoDTO.prototype.title = undefined;

/**
 * @member {Number} position
 */
TemplateCosoAmbitoDTO.prototype.position = undefined;

/**
 * @member {Boolean} dummy
 */
TemplateCosoAmbitoDTO.prototype.dummy = undefined;

/**
 * @member {Boolean} isQualitative
 */
TemplateCosoAmbitoDTO.prototype.isQualitative = undefined;

/**
 * @member {Boolean} isDeletable
 */
TemplateCosoAmbitoDTO.prototype.isDeletable = undefined;

/**
 * @member {Boolean} active
 */
TemplateCosoAmbitoDTO.prototype.active = undefined;

/**
 * @member {Number} poor
 */
TemplateCosoAmbitoDTO.prototype.poor = undefined;

/**
 * @member {Number} good
 */
TemplateCosoAmbitoDTO.prototype.good = undefined;

/**
 * @member {Number} unsatisfactory
 */
TemplateCosoAmbitoDTO.prototype.unsatisfactory = undefined;

/**
 * @member {Array.<module:model/TemplateQualitativeQuestionDTO>} templateQualitativeQuestions
 */
TemplateCosoAmbitoDTO.prototype.templateQualitativeQuestions = undefined;

/**
 * @member {String} tooltip
 */
TemplateCosoAmbitoDTO.prototype.tooltip = undefined;

